import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@masar/env/environment';
import { miscFunctions, Result } from 'mnm-webapp';
import { map } from 'rxjs/operators';
import { KpiResultPeriodFieldHistory } from '@masar/common/models';

@Injectable()
export class KpiResultPeriodService {
    public constructor(private httpClient: HttpClient) {}
    // Approval.
    public approve(periodId: string): Observable<string> {
        return this.httpClient
            .post<Result<any>>(
                `${environment.apiUrl}/kpi-result/period/approve`,
                miscFunctions.objectToURLParams({ periodId })
            )
            .pipe(map(res => res.messages[0]));
    }

    public disapprove(periodId: string): Observable<string> {
        return this.httpClient
            .post<Result<any>>(
                `${environment.apiUrl}/kpi-result/period/disapprove`,
                miscFunctions.objectToURLParams({ periodId })
            )
            .pipe(map(res => res.messages[0]));
    }

    public supervisorNote(periodId: string, notes: string): Observable<string> {
        return this.httpClient
            .post<Result<any>>(
                `${environment.apiUrl}/kpi-result/period/supervisor-note`,
                miscFunctions.objectToURLParams({
                    periodId,
                    notes,
                })
            )
            .pipe(map(res => res.messages[0]));
    }

    public leadershipDirective(
        periodId: string,
        directives: string
    ): Observable<string> {
        return this.httpClient
            .post<Result<any>>(
                `${environment.apiUrl}/kpi-result/period/leadership-directive`,
                miscFunctions.objectToURLParams({
                    periodId,
                    directives,
                })
            )
            .pipe(map(res => res.messages[0]));
    }

    public getFieldHistory(
        periodId: string,
        source: 'kpi-result' | 'data-entry-response'
    ): Observable<KpiResultPeriodFieldHistory> {
        return this.httpClient
            .get<Result<KpiResultPeriodFieldHistory>>(
                `${environment.apiUrl}/kpi-result-period/${periodId}/field-history`,
                {
                    params: new HttpParams().set('source', source),
                }
            )
            .pipe(
                map(result => {
                    const extra = result.extra as
                        KpiResultPeriodFieldHistory | null | undefined;
                    const fallback = result.extra as unknown as Record<
                        string,
                        | KpiResultPeriodFieldHistory['resultAnalysis']
                        | undefined
                    > | null;

                    return {
                        resultAnalysis:
                            extra?.resultAnalysis ??
                            fallback?.['ResultAnalysis'] ??
                            [],
                        improvementProcedure:
                            extra?.improvementProcedure ??
                            fallback?.['ImprovementProcedure'] ??
                            [],
                    };
                })
            );
    }
}
